import geicoLogo from '@/assets/marketing/carrier-logos/geico.png'
import progressiveLogo from '@/assets/marketing/carrier-logos/progressive.png'
import { CoverageType } from '@/models/insuranceCoverage'
import { CoiMode, type InsurancePolicy, PolicyStatus, Vendor } from '@/models/insurancePolicy'

const STAMP = '2026-10-01T00:00:00Z'

function coverage(
  id: string,
  coverageType: CoverageType,
  label: string,
  limit: number,
  deductible: number | null,
  premium: number
) {
  return {
    id,
    coverageType,
    vendorCoverageType: coverageType,
    limit,
    deductible,
    premium,
    premiumPerUnit: premium / 4,
    label,
    isPricePerTruck: false,
  }
}

export const MOCK_POLICY: InsurancePolicy = {
  id: 'ds-policy-auto',
  idShort: 'DSAUTO',
  dateCreated: STAMP,
  dateUpdated: STAMP,
  vendor: Vendor.PROGRESSIVE,
  vendorId: '06512345',
  vendorName: 'Progressive',
  broker: null,
  carrierId: null,
  label: 'Commercial auto',
  dateStart: '2026-10-01',
  dateEnd: '2027-10-01',
  dateCanceled: null,
  isCanceled: false,
  org: 'ds-org',
  application: 'ds-application',
  quote: null,
  policyDocument: null,
  coverages: [
    coverage('ds-al', CoverageType.AUTO_LIABILITY, 'Auto Liability', 1_000_000, null, 18_400),
    coverage('ds-pd', CoverageType.AUTO_PHYSICAL_DAMAGE, 'Physical Damage', 240_000, 2_500, 6_200),
  ],
  oneTimeFees: [{ id: 'ds-fee', label: 'Policy fee', amount: 250 }],
  premium: 24_850,
  premiumExcludingFees: 24_600,
  summary: null,
  coiMode: CoiMode.AUTOMATIC,
  isActive: true,
  status: PolicyStatus.ACTIVE,
  iconUrl: progressiveLogo,
  iconAlt: 'Progressive',
}

export const MOCK_CARGO_POLICY: InsurancePolicy = {
  ...MOCK_POLICY,
  id: 'ds-policy-cargo',
  idShort: 'DSCARGO',
  vendor: Vendor.GEICO,
  vendorId: 'MTC-4471902',
  vendorName: 'GEICO',
  label: 'Motor truck cargo',
  coverages: [coverage('ds-cargo', CoverageType.MOTOR_TRUCK_CARGO, 'Cargo', 100_000, 1_000, 2_150)],
  oneTimeFees: [],
  premium: 2_150,
  premiumExcludingFees: 2_150,
  iconUrl: geicoLogo,
  iconAlt: 'GEICO',
}

export const MOCK_SUMMARY =
  'Auto liability covers injury and property damage you cause to others, up to $1,000,000 per accident.\nPhysical damage repairs or replaces your own trucks after a collision, theft or fire, after a $2,500 deductible.'
